/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaxCheckRecogniseDocumentResult
 */
export interface PaxCheckRecogniseDocumentResult {
    /**
     * 
     * @type {Array<object>}
     * @memberof PaxCheckRecogniseDocumentResult
     */
    documents: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckRecogniseDocumentResult
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckRecogniseDocumentResult
     */
    documentType: string;
}

/**
 * Check if a given object implements the PaxCheckRecogniseDocumentResult interface.
 */
export function instanceOfPaxCheckRecogniseDocumentResult(value: object): value is PaxCheckRecogniseDocumentResult {
    if (!('documents' in value) || value['documents'] === undefined) return false;
    if (!('signature' in value) || value['signature'] === undefined) return false;
    if (!('documentType' in value) || value['documentType'] === undefined) return false;
    return true;
}

export function PaxCheckRecogniseDocumentResultFromJSON(json: any): PaxCheckRecogniseDocumentResult {
    return PaxCheckRecogniseDocumentResultFromJSONTyped(json, false);
}

export function PaxCheckRecogniseDocumentResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckRecogniseDocumentResult {
    if (json == null) {
        return json;
    }
    return {
        
        'documents': json['documents'],
        'signature': json['signature'],
        'documentType': json['document_type'],
    };
}

export function PaxCheckRecogniseDocumentResultToJSON(json: any): PaxCheckRecogniseDocumentResult {
    return PaxCheckRecogniseDocumentResultToJSONTyped(json, false);
}

export function PaxCheckRecogniseDocumentResultToJSONTyped(value?: PaxCheckRecogniseDocumentResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documents': value['documents'],
        'signature': value['signature'],
        'document_type': value['documentType'],
    };
}

